import { getSportingServiceURL } from 'services/sporting/utils/getSportingURL';
import { customFetch } from 'utils/customFetch';
import { UnexpectedError } from 'utils/errors';
import { SportingSecureParams, SportingSession } from 'services/sporting/types';
import { appendFormDataWithObjectValues } from 'utils/appendFormDataWithObjectValues';
import { createSportingHeaders } from 'services/sporting/utils/createSportingHeaders';

type Payload = {
  newPassword: string;
};

export const changePassword = async (
  params: SportingSecureParams<Payload>
): Promise<SportingSession> => {
  const { payload } = params;

  const endpointURL = getSportingServiceURL('changePassword');

  const headers = createSportingHeaders();

  const body = new FormData();
  appendFormDataWithObjectValues(body, payload);

  const response = await customFetch(endpointURL, {
    method: 'POST',
    headers,
    body
  });

  if (!response.ok) {
    throw new UnexpectedError();
  }

  return response.json();
};
